/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Midnight_LabelInputs */

const bn_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মধ্যরাত`)
};

const de_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitternacht`)
};

const el_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μεσάνυχτα`)
};

const en_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Midnight`)
};

const es_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medianoche`)
};

const fr_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuit`)
};

const hi_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मध्यरात्रि`)
};

const hu_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éjfél`)
};

const id_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tengah malam`)
};

const it_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mezzanotte`)
};

const ja_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`夜中`)
};

const ko_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자정`)
};

const nl_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middernacht`)
};

const pl_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Północ`)
};

const pt_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meia-noite`)
};

const ru_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полночь`)
};

const sv_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Midnatt`)
};

const tr_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gece yarısı`)
};

const uk_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`опівночі`)
};

const vi_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nửa đêm`)
};

const zh_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`午夜`)
};

const zh_hant_theme_midnight_label = /** @type {(inputs: Theme_Midnight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`午夜`)
};

/**
* | output |
* | --- |
* | "Midnight" |
*
* @param {Theme_Midnight_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const theme_midnight_label = /** @type {((inputs?: Theme_Midnight_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Midnight_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_theme_midnight_label(inputs)
	if (locale === "de") return de_theme_midnight_label(inputs)
	if (locale === "el") return el_theme_midnight_label(inputs)
	if (locale === "en") return en_theme_midnight_label(inputs)
	if (locale === "es") return es_theme_midnight_label(inputs)
	if (locale === "fr") return fr_theme_midnight_label(inputs)
	if (locale === "hi") return hi_theme_midnight_label(inputs)
	if (locale === "hu") return hu_theme_midnight_label(inputs)
	if (locale === "id") return id_theme_midnight_label(inputs)
	if (locale === "it") return it_theme_midnight_label(inputs)
	if (locale === "ja") return ja_theme_midnight_label(inputs)
	if (locale === "ko") return ko_theme_midnight_label(inputs)
	if (locale === "nl") return nl_theme_midnight_label(inputs)
	if (locale === "pl") return pl_theme_midnight_label(inputs)
	if (locale === "pt") return pt_theme_midnight_label(inputs)
	if (locale === "ru") return ru_theme_midnight_label(inputs)
	if (locale === "sv") return sv_theme_midnight_label(inputs)
	if (locale === "tr") return tr_theme_midnight_label(inputs)
	if (locale === "uk") return uk_theme_midnight_label(inputs)
	if (locale === "vi") return vi_theme_midnight_label(inputs)
	if (locale === "zh") return zh_theme_midnight_label(inputs)
	return zh_hant_theme_midnight_label(inputs)
});